var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3ebadc34b1078a3e122a331a79faf8c390bc48c3"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pit@pit"]={id:"3ebadc34b1078a3e122a331a79faf8c390bc48c3"};
      